import { createRouter, createWebHistory } from "vue-router";
import Localizer from "../Localizer.vue";
import routes_list from "./router";
import i18n, { isLocaleValid, getCurrentI18n } from "@/locales/i18n";
import HR from "@/routes/HR";
import store from "@/store";

export const checkLocale = (to, from, next) => {
  if (isLocaleValid(to.params.locale)) {
    next();
  } else {
    next({ ...to, params: { ...to.params, locale: getCurrentI18n() } });
  }
};


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "RealHome",
      redirect: `/${getCurrentI18n()}`,
    },
    {
      path: "/:locale",
      component: Localizer,
      beforeEnter: [checkLocale],
      children: [...routes_list, ...HR],
    },

    {
      path: "/loading",
      name: "loading",
      component: () => import("../components/FullPageLoading.vue"),
    },

    {
      path: "/:pathMatch(.*)*",
      name: "not_found",
      component: () => import("../pages/NotFound.vue"),
    },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 150 } };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const newLocale = to.params.locale;
  const prevLocale = from.params.locale;

  if (newLocale !== prevLocale) {
    await i18n.loadMessagesFor(newLocale);
    i18n.setLocale(newLocale);
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.state.user.token) {
      next({ name: "login_micro", params: { ...to.params, locale: getCurrentI18n() } });
      return;
    }
  } else {
    next();
    return;
  }

  if (to.name == "chart_layout") {
    const breadcrumb = to.meta.breadcrumb;
    if (breadcrumb) {
      to.meta.breadcrumb = [...breadcrumb, { label: to.params.layout }];
    }
  }

  if (to.name == "report_layout") {
    const breadcrumb = to.meta.breadcrumb;
    if (breadcrumb) {
      to.meta.breadcrumb = [...breadcrumb, { label: to.query.report_name }];
    }
  }

  if (to.name == "main_page" || to.name == "login") {
    to.meta.breadcrumb = null;
  }

  next();
});


export default router;
